import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { UniqueDialInChildConnectionPresentation } from './unique-dial-in-child-connection.presentation';
import { UniqueDialInChildConnectionVM } from './unique-dial-in-child-connection.viewmodel';
import { ChildConnectionFormProps } from '../types';

export const UniqueDialInChildConnectionForm = withViewModel(UniqueDialInChildConnectionPresentation, (props: ChildConnectionFormProps) => {
    const { accountId, eventId, childConnection, parentConnectionDetails, onChildConnectionUpdated } = props;
    return new UniqueDialInChildConnectionVM(accountId, eventId, childConnection, parentConnectionDetails, onChildConnectionUpdated);
});